export function nonenumerable (target, key, descriptor) {
  descriptor.writable = true;
  descriptor.enumerable = false;
  return descriptor;
}



// WEBPACK FOOTER //
// ./src/shared/decorators/nonenumerable.js